<template>
  <div :class="rootClass" data-test="share-button" aria-label="Share post">
    <ShareIcon class="war-room-share-button__icon" />
    Share
  </div>
</template>

<script lang="ts">
import type { PropOptions } from 'vue';
import Vue from 'vue';
import ShareIcon from './images/share-icon.vue.svg';

// That component can't have button tag because it's used in Dropdown button
// and nested buttons are not allowed
export default Vue.extend({
  name: 'WarRoomShareButton',
  components: {
    ShareIcon,
  },
  props: {
    variant: {
      type: String,
      default: 'outline',
      validator: (value: string) => ['outline', 'borderless'].includes(value),
    } as PropOptions<string>,
  },
  computed: {
    rootClass(): string[] {
      return ['war-room-share-button', `war-room-share-button--${this.variant}`];
    },
  },
});
</script>

<style scoped lang="scss">
.war-room-share-button {
  @include subhead-semibold;
  @include flex-center;
  @include color-hover(sub_text);

  padding: 5px 12px;
  color: var(--theme-color-sub-text);
  border-radius: 6px;
  border: 1px solid var(--theme-color-border);
  background: var(--theme-color-card);
  cursor: pointer;
  outline: none;
  appearance: none;

  &--borderless {
    border: none;
    padding: 0;
    background: transparent;
  }

  &__icon {
    margin-right: 6px;
    color: inherit;
  }
}
</style>
